/*
 * ELLBA STUDIO. – video loading
 * - The first video on the page loads right away (preload="auto", real src).
 * - Every other video carries <source data-src> + preload="none": it only gets its file
 *   when it scrolls into view, plays while visible and pauses when it leaves.
 * - prefers-reduced-motion and the a11y menu's "stop animations" keep videos paused on their poster.
 * - WCAG 2.2.2: a button with [data-ellba-vtoggle] next to a video pauses / plays it. Its label
 *   switches between data-label-pause and data-label-play, and a video the visitor paused stays
 *   paused (scrolling it back into view does not restart it).
 */
(function () {
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function still() {
    return reduce.matches || document.documentElement.classList.contains('a11y-still');
  }

  function hydrate(v) {
    if (v.dataset.ellbaLoaded) return;
    v.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    v.dataset.ellbaLoaded = '1';
    // load() would start a video that still has the autoplay attribute
    if (still()) v.autoplay = false;
    v.load();
  }

  function play(v) {
    if (still() || v.dataset.ellbaUserPaused) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function videoFor(btn) {
    var box = btn.parentElement;
    if (!box) return null;
    // Home page: the button sits in a zero-height box right after the linked video block.
    return box.querySelector('video') || (box.previousElementSibling && box.previousElementSibling.querySelector('video'));
  }

  function sync(btn) {
    var v = videoFor(btn);
    if (!v) return;
    var playing = !v.paused && !v.ended;
    btn.setAttribute('aria-label', playing ? btn.dataset.labelPause : btn.dataset.labelPlay);
    btn.dataset.state = playing ? 'playing' : 'paused';
  }

  function syncAll() {
    document.querySelectorAll('[data-ellba-vtoggle]').forEach(sync);
  }

  function init() {
    var lazy = document.querySelectorAll('video[data-ellba-lazy]');
    var eager = document.querySelectorAll('video[data-ellba-eager]');

    eager.forEach(function (v) {
      v.dataset.ellbaLoaded = '1';
      if (still()) v.pause();
    });

    document.querySelectorAll('video').forEach(function (v) {
      if (v.dataset.ellbaSync) return;
      v.dataset.ellbaSync = '1';
      v.addEventListener('play', syncAll);
      v.addEventListener('pause', syncAll);
    });
    syncAll();

    if (!('IntersectionObserver' in window)) {
      lazy.forEach(function (v) {
        hydrate(v);
        play(v);
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            hydrate(v);
            play(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    lazy.forEach(function (v) {
      io.observe(v);
    });
    // the eager (first) video also pauses when off screen
    eager.forEach(function (v) {
      io.observe(v);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ellba-vtoggle]');
    if (!btn) return;
    var v = videoFor(btn);
    if (!v) return;
    if (v.paused) {
      delete v.dataset.ellbaUserPaused;
      hydrate(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    } else {
      v.dataset.ellbaUserPaused = '1';
      v.pause();
    }
    sync(btn);
  });

  if (reduce.addEventListener) {
    reduce.addEventListener('change', function () {
      document.querySelectorAll('video').forEach(function (v) {
        if (still()) v.pause();
      });
      syncAll();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
